import { LegacyButton } from 'edrolo-style-guide';
import { Link } from 'react-router-dom';

/* eslint-disable react/prop-types */ // TODO: add props

export const LinkedButton = (props) => {
  const { to, children, ...restProps } = props;
  return (
    <Link to={to}>
      <LegacyButton {...restProps}>{children}</LegacyButton>
    </Link>
  );
};
